module.exports = __webpack_public_path__ + "static/img/chaungxin.eaaa3f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/chaungxin.jpg
// module id = 5OKW
// module chunks = 7